import { Deal } from '../gql/dealGql';
import { Auth0RoleName, Deal as GeneratedDeal, Maybe, User } from '../gql/generated/graphql';

export const getName = (name: string, opts?: { firstInitial?: boolean; lastInitial?: boolean }) => {
  if (!name || !opts) {
    return name;
  }

  const formattedName = [];
  const splitName = name.split(' ');
  if (splitName.length === 1) {
    return splitName[0];
  }

  const firstName = splitName[0];
  if (opts.firstInitial) {
    formattedName.push(firstName.charAt(0));
  } else {
    formattedName.push(firstName);
  }

  const lastName = splitName[splitName.length - 1];
  if (opts.lastInitial) {
    formattedName.push(lastName.charAt(0));
  } else {
    formattedName.push(lastName);
  }

  return formattedName.join(' ');
};

export const isUserAssignedToDeal = (user: User, deal?: Maybe<Deal> | Maybe<GeneratedDeal>) => {
  if (!deal) {
    return false;
  }

  return (
    deal.setter_id === user.id ||
    deal.setter?.id === user.id ||
    deal.structuring_manager_id === user.id ||
    deal.structuring_manager?.id === user.id ||
    deal.closer_id === user.id ||
    deal.closer?.id === user.id ||
    deal.closer2_id === user.id ||
    deal.closer2?.id === user.id ||
    deal.funding_clerk_id === user.id ||
    deal.funding_clerk?.id === user.id ||
    deal.title_clerk_id === user.id ||
    deal.title_clerk?.id === user.id ||
    deal.title_clerk2_id === user.id ||
    deal.title_clerk2?.id === user.id
  );
};

export const isUserAssignedTitleTeamLead = (user: User, deal?: Deal) => {
  if (!deal?.titling_pod?.leads?.length) {
    return false;
  }

  return deal.titling_pod.leads.some((lead) => lead.id === user.id);
};

export const filterUsersByRole = (users: Maybe<User>[], role: Auth0RoleName | Auth0RoleName[]) => {
  const roles = Array.isArray(role) ? role : [role];
  const normalizedRoles = roles.map((r) => r.toLowerCase());

  return users.filter((user) =>
    user?.auth0_roles?.roles?.some((r) =>
      normalizedRoles.includes(r?.name?.replace(/\s+/g, '').toLowerCase() ?? ''),
    ),
  );
};
